import type { ReactNode } from 'react';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { css } from '@sorare/css';

type Props = {
  title?: ReactNode;
  children?: ReactNode;
  onClick?: () => void;
  borderless?: boolean;
  disabled?: boolean;
};

const row = css`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  flex-direction: row;
  padding: 10px 0px;
  align-items: center;
  width: 100%;

  &.Mui-disabled {
    opacity: 0.5;
  }

  &:not(:first-child) {
    border-top: 1px solid var(--c-nd-200);
  }

  &[data-borderless] {
    border-top: none;
    padding: 4px 6px;
  }
`;

export const Row = ({
  title,
  children,
  onClick,
  borderless = false,
  disabled,
}: Props) => {
  const renderRow = () => (
    <>
      {title}
      {children}
    </>
  );

  if (onClick) {
    return (
      <ButtonBase
        className={row}
        data-borderless={borderless || undefined}
        onClick={onClick}
        disabled={disabled}
      >
        {renderRow()}
      </ButtonBase>
    );
  }

  return (
    <div className={row} data-borderless={borderless || undefined}>
      {renderRow()}
    </div>
  );
};
